// https://www.dbos.dev/privacy

import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaBuildYourReliableBackend } from '@components/layout/FooterCtas';

export function PrivacyPage() {
  return (
    <SiteLayout banner={true} footerCta={<FooterCtaBuildYourReliableBackend />}>
      <section className="hero-title">
        <h1 className="text-heading-h1">Privacy Policy</h1>
        <p className="text-body text-alignment-left">Last updated: November 2024</p>
      </section>
      <section className="legal-wrapper">
        <div className="text-body text-body-thin w-richtext">
          <p>
            DBOS, Inc<strong> </strong>(herein after<strong>{' “DBOS,” “we,” '}</strong>or<strong>{' “us”'}</strong>
            {') provides this privacy policy (the '}
            <strong>“Privacy Policy”</strong>) to explain how we collect, use, and disclose personally identifiable
            information (<strong>“Personal Information”</strong>
            {') about you when you visit a website that is owned and operated by us (the '}
            <strong>“Sites”</strong>), or when you otherwise interact with us. By visiting or using the Sites, you
            consent to our collection, use, disclosure, and processing of your information as described in this Privacy
            Policy. Please note that this Privacy Policy does not apply to any third-party websites, services, products,
            or applications, even if they are accessible through our Sites.
            <br />
            <br />
            We may change this Privacy Policy from time to time. If we make changes, we will notify you by revising the
            date at the top of this Privacy Policy. If you use the Sites after any changes to the Privacy Policy have
            been posted, that means you agree to all of the changes. We encourage you to review this Privacy Policy
            periodically to stay informed about our practices.
            <br />
            <br />
            {
              'We do not knowingly collect or solicit Personal Information from anyone under the age of 13. If you are under 13, please do not attempt to use the Sites or send any Personal Information about yourself to us. If we learn that we have collected Personal Information from a child under age 13, we will delete that information as quickly as possible. If you believe that a child under 13 may have provided us Personal Information, please contact us at contact@dbos.dev. \u00a0'
            }
            <br />
            <br />
          </p>
          <h2 className="text-heading-h4">Personal information we collect and what we use it for</h2>
          <p>
            Unless stated otherwise in detail in the relevant sections of the Sites, personal data generated from the
            use of our Sites is collected as follows, and it is stored for as long as required for the intended
            purposes.
            <br />
            <br />
            <strong>Information You Provide to Us</strong>
            <br />
            We collect Personal Information that you actively provide to us when you fill out a form on the Sites, or
            otherwise communicate with us. The types of Personal Information we may ask you to provide include your
            Name, Email address, Company, other Personal Information you choose to provide to us.
            <br />
            <br />
            <strong>Information We Collect Automatically When You Visit the Sites</strong>
            <br />
            When you access or use the Sites, we automatically collect certain Personal Information about you. This
            information includes:
            <br />
            <br />
            <strong>- Log Information:</strong>
            {
              ' We log Personal Information from your use of the Sites, including the type of device you use, access times, IP address, and pages viewed. We use this information for analytics and product improvement purposes.'
            }
            <br />
            <br />
            <strong>- Information Collected by Cookies and Other Tracking Technologies:</strong>
            {
              ' Browser cookies and web beacon (also known as “tracking pixels”) technologies are used to collect various Personal Information for analytics and product improvement purposes, such as seeing which areas and features of our Sites are popular, or determining whether an email has been opened and acted upon. Please note that if you choose to remove or reject cookies, this could affect the availability and functionality of the Sites.'
            }
            <br />
            <br />
            <strong>How We Use and Process Your Personal Information</strong>
            <br />
            We use your Personal Information for the following purposes:
            <br />- Respond to your comments, questions, job applications, and requests, and to provide customer
            service;
            <br />- Communicate with you about products, services, and events, and to provide information that we think
            may be of interest to you;
            <br />- Provide, deliver, maintain, test, monitor, and improve our Sites;
            <br />- Detect, investigate and prevent suspected breaches of the terms applicable to your use of our Sites;
            <br />- Other purposes that are not materially different from the purposes described above, unless you
            otherwise authorize us to do so.
            <br />
            {'\u200d'}
          </p>
          <h2 className="text-heading-h4">Sharing and protecting personal information</h2>
          <p>
            We may share your Personal Information with third parties as described in this section. If data is processed
            in countries outside the European Union, we will take appropriate measures to ensure that your personal data
            is processed in accordance with European data protection standards.
            <br />
            <br />
            <strong>{'- Agents and Service Providers: '}</strong>We may share your Personal Information with vendors,
            consultants and other service providers who need access to such information to perform work or provide
            services on our behalf. These third parties will only have access to your Personal Information as necessary
            to perform their functions, and may not use your Personal Information for any other purpose.
            <br />
            <br />
            <strong>{'- Analytics and Business Services: '}</strong>We may use third parties to provide analytics and
            business services in connection with the Site. Currently, 3rd-party services used include:
            <br />- Matomo, HotJar, PostHog - Site analytics
            <br />- Hubspot, ZoomWebinar - business services
            <br />
            <br />
            <strong>- Business Transfers:</strong>
            {
              ' We may choose to buy or sell assets, and may share and/or transfer customer information in connection with the evaluation of and entry into such transactions. Also, if we (or our assets) are acquired, or if we go out of business, enter bankruptcy, or go through some other change of control, Personal Information could be one of the assets transferred to or acquired by a third party.'
            }
            <br />
            <br />
            <strong>{'- Compelled Disclosures: '}</strong>We may disclose your Personal Information to government or law
            enforcement officials or to private parties as we, in our sole discretion, believe necessary or appropriate
            to:
            <br />- respond to claims and/or legal process (including subpoenas);
            <br />- protect the property and/or rights of DBOS or any third party;
            <br />- protect the safety of the public or any person;
            <br />- prevent or stop any illegal, unethical, or legally actionable activity;
            <br />- comply with applicable law or regulation; or
            <br />- respond to any lawful request by public authorities, including, without limitation, to meet national
            security or law enforcement requirements.
            <br />
            <br />
            <strong>Security</strong>
            <br />
            DBOS is committed to safeguarding the confidentiality of your Personal Information. As part of that
            commitment, we take reasonable administrative, physical, and electronic measures to help protect your
            Personal Information from loss, misuse, unauthorized access, disclosure, alteration or destruction. Please
            be aware, however, that no method of transmitting information over the Internet or storing of information is
            completely secure. Accordingly, we cannot guarantee the absolute security or secrecy of any of your Personal
            Information.
            <br />
            {'\u200d'}
          </p>
          <h2 className="text-heading-h4">Rights of the data subject</h2>
          <p>
            As the party affected by the processing of your data, you may claim certain rights under the GDPR and other
            relevant data protection regulations.
            <br />
            <br />
            RIGHT OF ACCESS - You have the right to request information on the data we hold about you at any time, and,
            if applicable, the recipients with whom we have shared your data.
            <br />
            <br />
            RIGHT TO RECTIFICATION - You have the right to request that we rectify inaccurate data relating to you.
            <br />
            <br />
            RIGHT TO ERASURE - You have the right to request that we erase your data, as long as the legal requirements
            for this are satisfied.
            <br />
            <br />
            RIGHT TO RESTRICTION OF PROCESSING - You have the right to request that we restrict processing of your data.
            <br />
            <br />
            RIGHT TO DATA PORTABILITY - You have the right to request that we transfer your data – if technically
            possible – to another responsible party.
            <br />
            <br />
            {
              'RIGHT TO OBJECT - \u00a0You have the right to object to the processing of your data at any time. In this case, we will cease to process your data. This does not apply if we can show that there are compelling legitimate grounds for processing that outweigh your interests, or if we need your data for the establishment, exercise or defense of legal claims.'
            }
            <br />
            <br />
            {
              'If you have any questions relating to our use of your personal data, please contact the DBOS Data Protection Officer via email at '
            }
            <a href="mailto:contact@dbos.dev" className="text-body-link">
              contact@dbos.dev
            </a>
            .<br />
            {'\u200d'}
          </p>
          <h2 className="text-heading-h4">Complaint to supervisory authorities</h2>
          <p>
            We take your concerns and rights very seriously. However, if you believe that we have not responded in an
            appropriate manner to your complaints or concerns, you have the right to lodge a complaint with your local
            data protection authority.
          </p>
        </div>
      </section>
    </SiteLayout>
  );
}
